import { render, staticRenderFns } from "./QuestionSelectother.vue?vue&type=template&id=185ddd02&scoped=true&"
import script from "./QuestionSelectother.vue?vue&type=script&lang=js&"
export * from "./QuestionSelectother.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelectother.vue?vue&type=style&index=0&id=185ddd02&lang=scss&scoped=true&"
import style1 from "./QuestionSelectother.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ddd02",
  null
  
)

export default component.exports